import {FuseRouteItemType} from '@/@fuse/utils/FuseUtils';
import {AUTH_ROLES} from '@/app/auth';

import RequestPhysicalCardPage from './RequestPhysicalCardPage';

const RequestPhysicalCardRoute: FuseRouteItemType = {
  path: '',
  element: <RequestPhysicalCardPage />,
  auth: AUTH_ROLES.parent,
};

export default RequestPhysicalCardRoute;
